import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card14 from "../Images/Profiles/Bernard.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function BernardByamukama() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Bernard Byamukama - Security"
        description="Bernard Byamukama completed his secondary education at the ordinary level. He holds a National certificate in Automotive Mechanics and Driving, which he earned from UBTEB. His career journey has included various roles, such as working as a Driver at Ibanda Light College Business. Additionally, Bernard has received training in security, which led to his employment as a Security Officer. He has been serving in this capacity for the past seven years."
        keywords="Bernard Byamukama, Security, CIRCODU, secondary education, ordinary level, National certificate, Automotive Mechanics, Driving, UBTEB, Ibanda Light College Business, Driver, security officer"
        url="/bernard-byamukama"
        image={Card14}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Bernard Byamukama</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Bernard Byamukama
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card14} alt="Mr. Bernard Byamukama" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Bernard Byamukama</h1>
                <p className="profile-card__role">Security</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Bernard Byamukama completed his secondary education at the
                  ordinary level. He holds a National certificate in Automotive
                  Mechanics and Driving, which he earned from UBTEB. His career
                  journey has included various roles, such as working as a
                  Driver at Ibanda Light College Business. Additionally, Bernard
                  has received training in security, which led to his employment
                  as a Security Officer. He has been serving in this capacity
                  for the past seven years.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=100078693347998"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256781893491"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:byamukamaben2020@gmail.com"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BernardByamukama;
